import { ColorHues } from "@chakra-ui/react";

// old
// export const PrimaryColors: ColorHues = {
//     50: "#FF9597",
//     100: "#FD6568",
//     200: "#F9383B",
//     300: "#F21115",
//     400: "#E90004",
//     500: "#DD0004",
//     600: "#CD0003",
//     700: "#B80003",
//     800: "#A00003",
//     900: "#870002",
// };

// export const PrimaryDarkColors: ColorHues = {
//     50: "#F5F5F5",
//     100: "#F0EEEE",
//     200: "#ECE7E7",
//     300: "#D5CCCD",
//     400: "#706868",
//     500: "#807777",
//     600: "#50494A",
//     700: "#2A2727",
//     800: "#131212",
//     900: "#0A0909",
// };
export const PrimaryColors: ColorHues = {
    50: "#D7F2DC",
    100: "#A8E1B3",
    200: "#79D08A",
    300: "#4BB062",
    400: "#2E9649",
    500: "#227938",
    600: "#1B6130",
    700: "#144928",
    800: "#0E3220",
    900: "#071B15",
};

export const PrimaryDarkColors: ColorHues = {
    50: "#E5F2E5",
    100: "#BEDAC0",
    200: "#97C39B",
    300: "#719C77",
    400: "#567855",
    500: "#405E41",
    600: "#2E4430",
    700: "#1C2A1F",
    800: "#0E1911",
    900: "#050D06",
};